import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Llegás a la clase sin saber exactamente qué WOD o rutina vas a dar hoy', 'Tus alumnos no progresan porque no tenés una secuencia clara de nivel a nivel', 'El 40% de los alumnos abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 o 15 ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnos de distintos niveles juntos y la clase se convierte en un caos', 'Fin de mes y los alumnos se van sin avisar porque la comunicación es inconsistente'];
  return <Section bg="dark-800" data-id="element-263">
      <div className="max-w-4xl mx-auto" data-id="element-264">
        <div className="text-center mb-6 md:mb-12" data-id="element-265">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold text-white leading-tight mb-4 md:mb-6" data-id="element-266">
            Si sos profe de funcional o cross training en Argentina,{' '}
            <span className="text-orange-500" data-id="element-267">
              esto te va a sonar familiar:
            </span>
          </h2>
        </div>

        <div className="bg-dark-900 border border-dark-700 rounded-3xl p-5 md:p-12 shadow-2xl" data-id="element-268">
          <ul className="space-y-3 md:space-y-6" data-id="element-269">
            {points.map((point, i) => <li key={i} className="flex items-start gap-3 md:gap-4" data-id="element-270">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-orange-500 flex-shrink-0 mt-0.5 md:mt-1" data-id="element-271" />
                <span className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-272">
                  {point}
                </span>
              </li>)}
          </ul>

          <div className="mt-6 pt-4 md:mt-12 md:pt-8 border-t border-dark-700 text-center" data-id="element-273">
            <h3 className="text-xl md:text-3xl font-display font-bold text-white" data-id="element-274">
              ¿Cuántas clases más vas a improvisar?
            </h3>
          </div>
        </div>
      </div>
    </Section>;
}